import { render } from "./SupportPage.vue?vue&type=template&id=19e192ca"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/support/SupportPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "19e192ca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('19e192ca', __exports__)) {
    api.reload('19e192ca', __exports__)
  }
  
  module.hot.accept("./SupportPage.vue?vue&type=template&id=19e192ca", () => {
    api.rerender('19e192ca', render)
  })

}


export default __exports__